import "react-toastify/dist/ReactToastify.css";
import "@assets/css/react-toastfy.css";
import "swiper/css";
import "swiper/css/navigation";
import "react-image-crop/dist/ReactCrop.css";
import posthog from "posthog-js";
import { setConfig } from "@shared/apis/fetch-clients/fetch-client-factory";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { AppRoutes } from "./routes/routes";
import { ErrorBoundaryProvider } from "@shared/components/ErrorBoundaryProvider";
import { ThemeProvider } from "@shared/providers/ThemeProvider";
import { AppConfirmDialog } from "@shared/components/AppConfirmDialog";
import { datadogService } from "@shared/services/datadog/datadog-service";
import { useDatadogEventTracking } from "@shared/services/datadog/useDatadogEventTracking";
import { useStagingWarning } from "@shared/hooks/useStagingWarning";
import { HelmetProvider } from "react-helmet-async";
import { queryClient } from "@shared/services/query-client";
import { PostHogProvider } from "posthog-js/react";
import { appConfig } from "@shared/utils/appConfig";
import { PostHogEventListener } from "@shared/services/posthog/PostHogEventListener";
import { posthogService } from "@shared/services/posthog/posthog-service";
import { ToastContainer } from "@shared/services/toast";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { GlobalStyles } from "@shared/theme/GlobalStyles";

setConfig({
  credentials: "include",
});

datadogService.init();
posthogService.init();

export const App = () => {
  useDatadogEventTracking();
  useStagingWarning();

  return (
    <HelmetProvider>
      <ThemeProvider>
        <GlobalStyles />
        <ErrorBoundaryProvider
          onResetError={() => window.location.replace("/")}
        >
          <PostHogProvider client={posthog}>
            <PostHogEventListener />
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <QueryClientProvider client={queryClient}>
                <AppRoutes />
                {appConfig.REACT_QUERY_DEV_TOOLS_ENABLED && (
                  <ReactQueryDevtools
                    initialIsOpen={false}
                    buttonPosition="bottom-right"
                  />
                )}
                <AppConfirmDialog />
                <ToastContainer />
              </QueryClientProvider>
            </LocalizationProvider>
          </PostHogProvider>
        </ErrorBoundaryProvider>
      </ThemeProvider>
    </HelmetProvider>
  );
};
